import { all, fork, put, takeEvery } from "redux-saga/effects";
import {
    PETTY_CASH_LOAD_PETTY_CASH_TOPBAR,
} from "../actions";
import {
    pettyCashGetPettyCashTopbar
} from "../../helpers/pettyCash-api";
import { NotificationManager } from '../../components/common/react-notifications';
import {
    getPettyCashTopbarDataSuccess,
} from "./actions";

const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}
//  PettyCash
function* pettyCashLoadPettyCashTopbar({ payload, token }) {
    try {
        const dt = new Date();
        const dateTime = `${dt.getFullYear().toString().padStart(4, '0')}/${(dt.getMonth() + 1).toString().padStart(2, '0')}/${dt.getDate().toString().padStart(2, '0')}`
        const dataRes = yield pettyCashGetPettyCashTopbar({ ...payload, dateTime }, token);
        if (dataRes.status === 'success') {
            yield put(getPettyCashTopbarDataSuccess(dataRes.data, dataRes.dataList));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// PettyCashTopList
export function* watchLoadPettyCashTopbar() {
    yield takeEvery(
        PETTY_CASH_LOAD_PETTY_CASH_TOPBAR,
        pettyCashLoadPettyCashTopbar
    );
}

export default function* rootSaga() {
    yield all([
        //  Book list
        fork(watchLoadPettyCashTopbar),
        // fork(watchLoadCompanyInformation),
        // fork(watchUpdateUser),
    ])
}